module.exports = __webpack_public_path__ + "img/TISCO.05f55301.png";